module.exports = __webpack_public_path__ + "img/OurServiceDigital_pic4.4fd41673.png";